import React from 'react'

import { connect } from 'react-redux'

import { useWelcomeExperience } from '@features/welcome-page'

import { getUserOrderById } from 'utils/user'

import { WelcomeFirstBoxOrderWrapper } from './WelcomeFirstBoxOrderWrapper'

function mapStateToProps(state: any) {
  const orderId = state.basket.get('orderId')
  const order = getUserOrderById(orderId, state.user.get('orders'))

  return {
    periodId: String(order.getIn(['period', 'id'])),
  }
}

type WelcomeFirstBoxOrderWrapperContainerProps = ReturnType<typeof mapStateToProps> & {
  isSignUpSeamlessFlowIntoPlanningEnabled: boolean
}

function WelcomeFirstBoxOrderWrapperContainerComponent({
  periodId,
  isSignUpSeamlessFlowIntoPlanningEnabled,
}: WelcomeFirstBoxOrderWrapperContainerProps) {
  const { header } = useWelcomeExperience()

  return (
    <WelcomeFirstBoxOrderWrapper
      header={header}
      periodId={periodId}
      isSignUpSeamlessFlowIntoPlanningEnabled={isSignUpSeamlessFlowIntoPlanningEnabled}
    />
  )
}

const WelcomeFirstBoxOrderWrapperContainer = connect(mapStateToProps)(
  WelcomeFirstBoxOrderWrapperContainerComponent,
)

export { WelcomeFirstBoxOrderWrapperContainer }
